import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const UserDirectoryTable = ({
  users,
  loading,
  selectedUsers,
  onUserSelect,
  onBulkSelect,
  onSelectAll
}) => {
  if (loading) {
    return (
      <div className="bg-card rounded-lg p-8 shadow-elevation-md text-center">
        <Icon name="Loader" size={48} className="animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Loading users...</p>
      </div>
    );
  }

  if (users?.length === 0) {
    return (
      <div className="bg-card rounded-lg p-8 shadow-elevation-md text-center">
        <Icon name="Users" size={64} className="text-muted-foreground mx-auto mb-4" />
        <p className="text-muted-foreground">No users found</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="px-4 py-3 text-left">
                <Checkbox
                  checked={selectedUsers?.length === users?.length}
                  onChange={onSelectAll}
                />
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                User
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                Role
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                Rating
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                Trips
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {users?.map((user) => (
              <tr
                key={user?.id}
                className="hover:bg-muted/50 transition-colors cursor-pointer"
                onClick={() => onUserSelect(user)}
              >
                <td className="px-4 py-3" onClick={(e) => e?.stopPropagation()}>
                  <Checkbox
                    checked={selectedUsers?.includes(user?.id)}
                    onChange={() => onBulkSelect(user?.id)}
                  />
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    {user?.avatar_url ? (
                      <img
                        src={user?.avatar_url}
                        alt={user?.full_name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                        <Icon name="User" size={20} className="text-primary" />
                      </div>
                    )}
                    <div>
                      <p className="font-medium text-foreground">{user?.full_name}</p>
                      <p className="text-xs text-muted-foreground">{user?.email}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span
                    className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                      user?.role === 'admin' ?'bg-destructive/10 text-destructive'
                        : user?.role === 'traveler' ?'bg-purple-500/10 text-purple-500' :'bg-blue-500/10 text-blue-500'
                    }`}
                  >
                    <Icon
                      name={
                        user?.role === 'admin' ?'Shield'
                          : user?.role === 'traveler' ?'Plane' :'ShoppingBag'
                      }
                      size={12}
                    />
                    {user?.role}
                  </span>
                </td>
                <td className="px-4 py-3">
                  {user?.is_verified ? (
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
                      <Icon name="BadgeCheck" size={12} />
                      Verified
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-warning/10 text-warning">
                      <Icon name="AlertCircle" size={12} />
                      Unverified
                    </span>
                  )}
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-1">
                    <Icon name="Star" size={14} className="text-warning fill-warning" />
                    <span className="text-sm font-medium text-foreground">
                      {user?.rating?.toFixed(2) || '0.00'}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-foreground">
                    {user?.completed_trips || 0}
                  </span>
                </td>
                <td className="px-4 py-3" onClick={(e) => e?.stopPropagation()}>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Eye"
                    onClick={() => onUserSelect(user)}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserDirectoryTable;